import { creategetRequest } from './request';
import { URL_GET_CONFIG } from '../../constants';

const url = 'api/';

export const getConfigData = () => {
  return creategetRequest(url + URL_GET_CONFIG)
    .then((res) => res.data.payload)
    .catch((err) => err);
};
